import { useMutation } from '@apollo/client';
import { SET_VACATION_MODE, USER } from '../userTypeDefs';

export const useMutationSetVacationMode = (options?: any): any =>
  useMutation(SET_VACATION_MODE, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
    ...options,
  });


